import React, { Component } from 'react';
import "./button.css"

class HyhButton extends Component {

    state = {
        btnTxt: 'Login'
    }

    render() {
        const { btnTxt } = this.state;
        return (
            <div className='button-container' onClick={() => { this.setState({ btnTxt: btnTxt === 'Login' ? 'Logout' : 'Login' }) }}>
                <span>{btnTxt}</span>
            </div>
        );
    }
}

export default HyhButton;